import { render, staticRenderFns } from "./BranchQue2.vue?vue&type=template&id=0df714f2&scoped=true&lang=pug"
import script from "./BranchQue2.vue?vue&type=script&lang=js"
export * from "./BranchQue2.vue?vue&type=script&lang=js"
import style0 from "./BranchQue2.vue?vue&type=style&index=0&id=0df714f2&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df714f2",
  null
  
)

export default component.exports